import { render, staticRenderFns } from "./DadosServico.vue?vue&type=template&id=fdbe4a3e"
import script from "./DadosServico.vue?vue&type=script&lang=js"
export * from "./DadosServico.vue?vue&type=script&lang=js"
import style0 from "./DadosServico.vue?vue&type=style&index=0&id=fdbe4a3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports